import { Component, OnInit, signal } from '@angular/core';
import { AuthService } from './core/services/auth';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css',
})
export class App implements OnInit {
  protected readonly title = signal('sistema-longavi');

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // this.authService.initSession().subscribe((logged: boolean) => {
    //   console.log(logged);
    //   if (logged) {
    //     this.authService.checkRolesModulos().subscribe();
    //   }
    // });
    initFlowbite();
  }
}
